document.addEventListener('DOMContentLoaded', function () {
  const quickOrderSections = document.querySelectorAll('[data-abz-quick-order]');

  quickOrderSections.forEach(function (section) {
    initAbzStickyOffset(section);
    initAbzNavigation(section);
    initAbzQuickOrder(section);
  });
});

function initAbzStickyOffset(section) {
  section.style.setProperty('--abz-sticky-offset', '0px');
}

/* =========================================================
   COLLECTION-ID BASED NAVIGATION
========================================================== */

function initAbzNavigation(section) {
  const stickyWrapper = section.querySelector('[data-abz-sticky-nav-wrapper]');
  const nav = section.querySelector('[data-abz-sticky-nav]');
  const links = Array.from(section.querySelectorAll('[data-abz-collection-target]'));

  if (!stickyWrapper || !nav || !links.length) return;

  let clickLock = false;
  let clickLockTimer = null;

  const items = links
    .map(function (link) {
      const collectionTarget = link.getAttribute('data-abz-collection-target');
      const category = section.querySelector(
        '[data-abz-collection-section="' + collectionTarget + '"]'
      );

      if (!category) return null;

      const title = category.querySelector('.abz-quick-order__category-title');
      const products = category.querySelector('[data-abz-category-products]');

      return {
        link: link,
        collectionTarget: collectionTarget,
        category: category,
        title: title || category,
        products: products || category
      };
    })
    .filter(Boolean);

  if (!items.length) return;

  function setActive(link) {
    if (!link) return;

    links.forEach(function (item) {
      item.classList.remove('active');
    });

    link.classList.add('active');

    const navRect = nav.getBoundingClientRect();
    const linkRect = link.getBoundingClientRect();

    if (linkRect.left < navRect.left || linkRect.right > navRect.right) {
      link.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }

  function getStickyHeight() {
    return stickyWrapper.offsetHeight || 52;
  }

  function getTargetTop(item) {
    const targetTop = item.title.getBoundingClientRect().top + window.pageYOffset;
    return targetTop - getStickyHeight() - 24;
  }

  function scrollToItem(item) {
    clickLock = true;
    setActive(item.link);

    window.scrollTo({
      top: Math.max(0, getTargetTop(item)),
      behavior: 'smooth'
    });

    window.clearTimeout(clickLockTimer);

    clickLockTimer = window.setTimeout(function () {
      window.scrollTo({
        top: Math.max(0, getTargetTop(item)),
        behavior: 'auto'
      });

      clickLock = false;
      updateActiveFromScroll();
    }, 750);
  }

  items.forEach(function (item) {
    item.link.addEventListener('click', function (event) {
      event.preventDefault();
      scrollToItem(item);
    });
  });

  function updateActiveFromScroll() {
    if (clickLock) return;

    const currentPosition = window.scrollY + getStickyHeight() + 80;
    let activeItem = items[0];

    items.forEach(function (item) {
      const categoryTop = item.category.getBoundingClientRect().top + window.pageYOffset;

      if (currentPosition >= categoryTop) {
        activeItem = item;
      }
    });

    if (activeItem && activeItem.link) {
      setActive(activeItem.link);
    }
  }

  let ticking = false;

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(function () {
        updateActiveFromScroll();
        ticking = false;
      });
    },
    { passive: true }
  );

  window.addEventListener('resize', updateActiveFromScroll);

  setActive(items[0].link);
  updateActiveFromScroll();
}

/* =========================================================
   QUICK ORDER CART LOGIC WITH GERMAN TRANSLATIONS (Original code preserved)
========================================================== */

function initAbzQuickOrder(section) {
  const rows = Array.from(section.querySelectorAll('[data-abz-quick-order-row]'));
  const countElement = section.querySelector('[data-selected-count]');
  const subtotalElement = section.querySelector('[data-subtotal]');
  const addButton = section.querySelector('[data-add-all-to-cart]');
  const redirectTarget = section.dataset.redirectTarget || 'drawer';

  if (!rows.length || !countElement || !subtotalElement || !addButton) return;

  const currency =
    window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'EUR';

  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
    style: 'currency',
    currency: currency
  });

  rows.forEach(function (row) {
    const minusButton = row.querySelector('[data-qty-minus]');
    const plusButton = row.querySelector('[data-qty-plus]');
    const input = row.querySelector('[data-qty-input]');

    if (!input) return;

    if (minusButton) {
      minusButton.addEventListener('click', function () {
        const currentValue = parseInt(input.value || '0', 10);
        input.value = Math.max(0, currentValue - 1);
        updateSummary();
      });
    }

    if (plusButton) {
      plusButton.addEventListener('click', function () {
        const currentValue = parseInt(input.value || '0', 10);
        input.value = currentValue + 1;
        updateSummary();
      });
    }

    input.addEventListener('input', function () {
      let value = parseInt(input.value || '0', 10);

      if (Number.isNaN(value) || value < 0) {
        value = 0;
      }

      input.value = value;
      updateSummary();
    });

    input.addEventListener('blur', function () {
      if (input.value === '') {
        input.value = 0;
      }
      updateSummary();
    });
  });

  addButton.addEventListener('click', addAllItemsToCart);

  function getSelectedItems() {
    return rows
      .map(function (row) {
        const input = row.querySelector('[data-qty-input]');
        const quantity = parseInt(input && input.value ? input.value : '0', 10);

        return {
          id: Number(row.dataset.variantId),
          quantity: quantity,
          price: Number(row.dataset.price)
        };
      })
      .filter(function (item) {
        return item.id && item.quantity > 0;
      });
  }

  function updateSummary() {
    const selectedItems = getSelectedItems();

    const totalQuantity = selectedItems.reduce(function (sum, item) {
      return sum + item.quantity;
    }, 0);

    const subtotal = selectedItems.reduce(function (sum, item) {
      return sum + item.price * item.quantity;
    }, 0);

    countElement.textContent =
      totalQuantity === 1
        ? '1 Produkt ausgewählt'
        : totalQuantity + ' Produkte ausgewählt';

    subtotalElement.textContent = 'Zwischensumme: ' + formatter.format(subtotal / 100);
    addButton.disabled = selectedItems.length === 0;
    addButton.textContent = 'Alle Artikel in den Warenkorb legen';
  }

  async function addAllItemsToCart() {
    const selectedItems = getSelectedItems();

    if (!selectedItems.length) return;

    addButton.disabled = true;
    addButton.classList.add('is-loading');
    addButton.textContent = 'Wird hinzugefügt…';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: selectedItems.map(function (item) {
            return {
              id: item.id,
              quantity: item.quantity
            };
          })
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Unable to add selected items to cart.');
      }

      if (redirectTarget === 'checkout') {
        window.location.href = '/checkout';
        return;
      }

      if (redirectTarget === 'cart') {
        window.location.href = '/cart';
        return;
      }

      await refreshCartState();
      openCartDrawer();
      resetSelectedQuantities();
      addButton.disabled = true;
      addButton.classList.remove('is-loading');
      addButton.textContent = 'Alle Artikel in den Warenkorb legen';
    } catch (error) {
      console.error(error);
      alert(error.message || 'Einige Artikel konnten nicht in den Warenkorb gelegt werden.');

      addButton.disabled = false;
      addButton.classList.remove('is-loading');
      addButton.textContent = 'Alle Artikel in den Warenkorb legen';
    }
  }

  async function refreshCartState() {
    try {
      const response = await fetch('/cart.js', {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();

      ['cart:refresh', 'cart:updated', 'theme:cart:updated'].forEach(function (eventName) {
        document.dispatchEvent(
          new CustomEvent(eventName, {
            bubbles: true,
            detail: { cart: cart }
          })
        );
      });
    } catch (error) {
      console.warn('Cart refresh event failed:', error);
    }
  }

  function openCartDrawer() {
    const possibleCartTriggers = [
      '[aria-controls="cart-drawer"]',
      '[aria-controls="CartDrawer"]',
      '[aria-controls*="cart"]',
      '[data-action="open-cart-drawer"]',
      '[data-drawer-id="cart"]',
      '.Header__CartIcon',
      '.header__cart',
      '.cart-count-bubble'
    ];

    for (let i = 0; i < possibleCartTriggers.length; i++) {
      const trigger = document.querySelector(possibleCartTriggers[i]);

      if (trigger) {
        trigger.click();
        return;
      }
    }

    window.location.href = '/cart';
  }

  function resetSelectedQuantities() {
    rows.forEach(function (row) {
      const input = row.querySelector('[data-qty-input]');

      if (input && !input.disabled) {
        input.value = 0;
      }
    });

    updateSummary();
  }

  updateSummary();
}


// document.addEventListener('DOMContentLoaded', function () {
//   const quickOrderSections = document.querySelectorAll('[data-abz-quick-order]');

//   quickOrderSections.forEach(function (section) {
//     initAbzStickyOffset(section);
//     initAbzNavigation(section);
//     initAbzQuickOrder(section);
//   });
// });

// function initAbzStickyOffset(section) {
//   section.style.setProperty('--abz-sticky-offset', '0px');
// }

// /* =========================================================
//    COLLECTION-ID BASED NAVIGATION
// ========================================================== */

// function initAbzNavigation(section) {
//   const stickyWrapper = section.querySelector('[data-abz-sticky-nav-wrapper]');
//   const nav = section.querySelector('[data-abz-sticky-nav]');
//   const links = Array.from(section.querySelectorAll('[data-abz-collection-target]'));

//   if (!stickyWrapper || !nav || !links.length) return;

//   let clickLock = false;
//   let clickLockTimer = null;

//   const items = links
//     .map(function (link) {
//       const collectionTarget = link.getAttribute('data-abz-collection-target');
//       const category = section.querySelector(
//         '[data-abz-collection-section="' + collectionTarget + '"]'
//       );

//       if (!category) return null;

//       const title = category.querySelector('.abz-quick-order__category-title');
//       const products = category.querySelector('[data-abz-category-products]');

//       return {
//         link: link,
//         collectionTarget: collectionTarget,
//         category: category,
//         title: title || category,
//         products: products || category
//       };
//     })
//     .filter(Boolean);

//   if (!items.length) return;

//   function setActive(link) {
//     if (!link) return;

//     links.forEach(function (item) {
//       item.classList.remove('active');
//     });

//     link.classList.add('active');

//     const navRect = nav.getBoundingClientRect();
//     const linkRect = link.getBoundingClientRect();

//     if (linkRect.left < navRect.left || linkRect.right > navRect.right) {
//       link.scrollIntoView({
//         behavior: 'smooth',
//         inline: 'center',
//         block: 'nearest'
//       });
//     }
//   }

//   function getStickyHeight() {
//     return stickyWrapper.offsetHeight || 52;
//   }

//   function getTargetTop(item) {
//     const targetTop = item.title.getBoundingClientRect().top + window.pageYOffset;
//     return targetTop - getStickyHeight() - 24;
//   }

//   function scrollToItem(item) {
//     clickLock = true;
//     setActive(item.link);

//     window.scrollTo({
//       top: Math.max(0, getTargetTop(item)),
//       behavior: 'smooth'
//     });

//     window.clearTimeout(clickLockTimer);

//     clickLockTimer = window.setTimeout(function () {
//       window.scrollTo({
//         top: Math.max(0, getTargetTop(item)),
//         behavior: 'auto'
//       });

//       clickLock = false;
//       updateActiveFromScroll();
//     }, 750);
//   }

//   items.forEach(function (item) {
//     item.link.addEventListener('click', function (event) {
//       event.preventDefault();
//       scrollToItem(item);
//     });
//   });

//   function updateActiveFromScroll() {
//     if (clickLock) return;

//     const currentPosition = window.scrollY + getStickyHeight() + 80;
//     let activeItem = items[0];

//     items.forEach(function (item) {
//       const categoryTop = item.category.getBoundingClientRect().top + window.pageYOffset;

//       if (currentPosition >= categoryTop) {
//         activeItem = item;
//       }
//     });

//     if (activeItem && activeItem.link) {
//       setActive(activeItem.link);
//     }
//   }

//   let ticking = false;

//   window.addEventListener(
//     'scroll',
//     function () {
//       if (ticking) return;

//       ticking = true;

//       window.requestAnimationFrame(function () {
//         updateActiveFromScroll();
//         ticking = false;
//       });
//     },
//     { passive: true }
//   );

//   window.addEventListener('resize', updateActiveFromScroll);

//   setActive(items[0].link);
//   updateActiveFromScroll();
// }

// /* =========================================================
//    QUICK ORDER CART LOGIC
// ========================================================== */

// function initAbzQuickOrder(section) {
//   const rows = Array.from(section.querySelectorAll('[data-abz-quick-order-row]'));
//   const countElement = section.querySelector('[data-selected-count]');
//   const subtotalElement = section.querySelector('[data-subtotal]');
//   const addButton = section.querySelector('[data-add-all-to-cart]');
//   const redirectTarget = section.dataset.redirectTarget || 'drawer';

//   if (!rows.length || !countElement || !subtotalElement || !addButton) return;

//   const currency =
//     window.Shopify && window.Shopify.currency && window.Shopify.currency.active
//       ? window.Shopify.currency.active
//       : 'EUR';

//   const formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
//     style: 'currency',
//     currency: currency
//   });

//   rows.forEach(function (row) {
//     const minusButton = row.querySelector('[data-qty-minus]');
//     const plusButton = row.querySelector('[data-qty-plus]');
//     const input = row.querySelector('[data-qty-input]');

//     if (!input) return;

//     if (minusButton) {
//       minusButton.addEventListener('click', function () {
//         const currentValue = parseInt(input.value || '0', 10);
//         input.value = Math.max(0, currentValue - 1);
//         updateSummary();
//       });
//     }

//     if (plusButton) {
//       plusButton.addEventListener('click', function () {
//         const currentValue = parseInt(input.value || '0', 10);
//         input.value = currentValue + 1;
//         updateSummary();
//       });
//     }

//     input.addEventListener('input', function () {
//       let value = parseInt(input.value || '0', 10);

//       if (Number.isNaN(value) || value < 0) {
//         value = 0;
//       }

//       input.value = value;
//       updateSummary();
//     });

//     input.addEventListener('blur', function () {
//       if (input.value === '') {
//         input.value = 0;
//       }

//       updateSummary();
//     });
//   });

//   addButton.addEventListener('click', addAllItemsToCart);

//   function getSelectedItems() {
//     return rows
//       .map(function (row) {
//         const input = row.querySelector('[data-qty-input]');
//         const quantity = parseInt(input && input.value ? input.value : '0', 10);

//         return {
//           id: Number(row.dataset.variantId),
//           quantity: quantity,
//           price: Number(row.dataset.price)
//         };
//       })
//       .filter(function (item) {
//         return item.id && item.quantity > 0;
//       });
//   }

//   function updateSummary() {
//     const selectedItems = getSelectedItems();

//     const totalQuantity = selectedItems.reduce(function (sum, item) {
//       return sum + item.quantity;
//     }, 0);

//     const subtotal = selectedItems.reduce(function (sum, item) {
//       return sum + item.price * item.quantity;
//     }, 0);

//     countElement.textContent =
//       totalQuantity === 1
//         ? '1 Product Selected'
//         : totalQuantity + ' Products Selected';

//     subtotalElement.textContent = 'Subtotal: ' + formatter.format(subtotal / 100);
//     addButton.disabled = selectedItems.length === 0;
//   }

//   async function addAllItemsToCart() {
//     const selectedItems = getSelectedItems();

//     if (!selectedItems.length) return;

//     addButton.disabled = true;
//     addButton.classList.add('is-loading');

//     try {
//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           Accept: 'application/json'
//         },
//         body: JSON.stringify({
//           items: selectedItems.map(function (item) {
//             return {
//               id: item.id,
//               quantity: item.quantity
//             };
//           })
//         })
//       });

//       if (!response.ok) {
//         const error = await response.json();
//         throw new Error(error.description || 'Unable to add selected items to cart.');
//       }

//       if (redirectTarget === 'checkout') {
//         window.location.href = '/checkout';
//         return;
//       }

//       if (redirectTarget === 'cart') {
//         window.location.href = '/cart';
//         return;
//       }

//       await refreshCartState();
//       openCartDrawer();
//       resetSelectedQuantities();
//       addButton.disabled = true;
//       addButton.classList.remove('is-loading');
//     } catch (error) {
//       console.error(error);
//       alert(error.message || 'Some items could not be added to cart.');

//       addButton.disabled = false;
//       addButton.classList.remove('is-loading');
//     }
//   }

//   async function refreshCartState() {
//     try {
//       const response = await fetch('/cart.js', {
//         method: 'GET',
//         headers: {
//           Accept: 'application/json'
//         }
//       });

//       if (!response.ok) return;

//       const cart = await response.json();

//       ['cart:refresh', 'cart:updated', 'theme:cart:updated'].forEach(function (eventName) {
//         document.dispatchEvent(
//           new CustomEvent(eventName, {
//             bubbles: true,
//             detail: { cart: cart }
//           })
//         );
//       });
//     } catch (error) {
//       console.warn('Cart refresh event failed:', error);
//     }
//   }

//   function openCartDrawer() {
//     const possibleCartTriggers = [
//       '[aria-controls="cart-drawer"]',
//       '[aria-controls="CartDrawer"]',
//       '[aria-controls*="cart"]',
//       '[data-action="open-cart-drawer"]',
//       '[data-drawer-id="cart"]',
//       '.Header__CartIcon',
//       '.header__cart',
//       '.cart-count-bubble'
//     ];

//     for (let i = 0; i < possibleCartTriggers.length; i++) {
//       const trigger = document.querySelector(possibleCartTriggers[i]);

//       if (trigger) {
//         trigger.click();
//         return;
//       }
//     }

//     window.location.href = '/cart';
//   }

//   function resetSelectedQuantities() {
//     rows.forEach(function (row) {
//       const input = row.querySelector('[data-qty-input]');

//       if (input && !input.disabled) {
//         input.value = 0;
//       }
//     });

//     updateSummary();
//   }

//   updateSummary();
// }